import styled from 'styled-components';
import { darken } from 'polished';

const SequencerStyles = styled.div`
   @media (min-width: 1150px) {
      display: flex;
      justify-content: center;

      .sequencer-wrapper {
         max-width: calc(var(--safe-width) - 20px);
      }
   }

   --sequencer-zone-height: calc(
      var(--visible-and-safe-height) - 2 * var(--header-height) -
         var(--exercise-bottom-padding) - var(--below-interface-height)
   );

   @media (max-height: 550px) {
      --sequencer-zone-height: calc(
         var(--visible-and-safe-height) - var(--header-height) -
            var(--exercise-bottom-padding) - var(--below-interface-height)
      );
   }

   &.piano-roll-or-step-sequencer {
      --included-header-height: var(--header-height);
      @media (max-height: 550px) {
         --included-header-height: 0px;
      }

      --sequencer-zone-height: calc(
         var(--visible-and-safe-height) - 130px - var(--included-header-height) -
            var(--exercise-bottom-padding) - var(--below-interface-height)
      );

      @media (min-width: 500px) and (max-height: 550px),
         (min-width: 450px) and (min-height: 551px) {
         --sequencer-zone-height: calc(
            var(--visible-and-safe-height) - var(--header-height) -
               var(--included-header-height) - 20px -
               var(--exercise-bottom-padding) - var(--below-interface-height)
         );
      }
   }

   .controls-wrapper {
      flex-wrap: wrap;
      justify-content: left;
   }

   .play-buttons {
      width: 100%;
      padding-right: 1em;

      button {
         max-width: calc((100% - 1em) / 2);
         & > span {
            width: 100%;
         }
      }

      .play-button-text {
         max-width: calc(100% - 24px - 0.75em);
         overflow: hidden;
         text-overflow: ellipsis;
      }

      @media (min-width: 600px) and (max-height: 550px),
         (min-width: 550px) and (min-height: 551px) {
         padding-right: 0;
      }

      @media (max-height: 550px) {
         width: calc(100% - 50px);
         padding-top: 10px;
      }

      @media (min-width: 500px) and (max-height: 550px) {
         width: 100%;
         max-width: min(20em, calc(100% - 18em));
         padding-top: 0;
      }

      @media (min-width: 450px) and (min-height: 551px) {
         width: 100%;
         max-width: min(20em, calc(100% - 15em));
         padding-top: 0;
      }
   }

   .reference-toggle-button {
      display: inline-flex;
      vertical-align: top;
      transition: none;

      &:hover,
      &:focus-visible,
      &:active {
         color: var(--brand-darker-orange);
      }

      @media (prefers-color-scheme: dark) {
         &:hover,
         &:focus-visible,
         &:active {
            color: var(--hover-color);
         }
      }

      > span {
         display: inline-flex;
         align-items: center;
      }

      svg {
         margin-right: 0.75em;
         margin-left: 0.75em;
      }

      &.reference-toggle-button-playing:not(.reference-toggle-button-reference)
         .reference-toggle-text-yours {
         color: var(--brand-orange);
      }

      &.reference-toggle-button-playing.reference-toggle-button-reference
         .reference-toggle-text-reference {
         color: var(--brand-orange);
      }

      &.reference-toggle-button-playing:not(
            .reference-toggle-button-reference
         ):hover
         .reference-toggle-text-yours,
      &.reference-toggle-button-playing:not(
            .reference-toggle-button-reference
         ):focus-visible
         .reference-toggle-text-yours,
      &.reference-toggle-button-playing:not(
            .reference-toggle-button-reference
         ):active
         .reference-toggle-text-yours {
         color: var(--brand-white);
      }

      &.reference-toggle-button-playing.reference-toggle-button-reference:hover
         .reference-toggle-text-reference,
      &.reference-toggle-button-playing.reference-toggle-button-reference:focus-visible
         .reference-toggle-text-reference,
      &.reference-toggle-button-playing.reference-toggle-button-reference:active
         .reference-toggle-text-reference {
         color: var(--brand-white);
      }
   }

   @media (prefers-color-scheme: dark) {
      .reference-toggle-button {
         &.reference-toggle-button-playing:not(
               .reference-toggle-button-reference
            )
            .reference-toggle-text-yours {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing.reference-toggle-button-reference
            .reference-toggle-text-reference {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing:not(
               .reference-toggle-button-reference
            ):hover
            .reference-toggle-text-yours {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing:not(
               .reference-toggle-button-reference
            ):focus-visible
            .reference-toggle-text-yours {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing:not(
               .reference-toggle-button-reference
            ):active
            .reference-toggle-text-yours {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing.reference-toggle-button-reference:hover
            .reference-toggle-text-reference {
            color: var(--brand-light-orange);
         }

         &.reference-toggle-button-playing.reference-toggle-button-reference:focus-visible
            .reference-toggle-text-reference {
            color: var(--brand-light-orange);
         }
         &.reference-toggle-button-playing.reference-toggle-button-reference:active
            .reference-toggle-text-reference {
            color: var(--brand-light-orange);
         }
      }
   }

   .swing-tempo-buttons {
      margin-top: 10px;

      @media (min-width: 500px) and (max-height: 550px),
         (min-width: 450px) and (min-height: 551px) {
         margin-top: 0px;
      }
   }

   .swing-control {
      overflow: visible;
      touch-action: none;
      vertical-align: bottom;
      text {
         fill: var(--text-color);
         font-family: var(--content-font);
         font-weight: bold;
         font-size: 0.8em;
      }
   }

   .tempo-control {
      margin-left: 1.5em;
      button {
         padding: 0.5em 0.25em;
         z-index: 1;
         position: relative;
      }
      button:first-child {
         border-bottom-right-radius: 0;
         border-top-right-radius: 0;
         margin-right: 0;
      }
      button:last-child {
         border-bottom-left-radius: 0;
         border-top-left-radius: 0;
      }

      .tempo-value {
         border: 2px solid;
         padding: 0.5em 1em;
         font-family: var(--content-font);
         font-weight: bold;
         font-size: 1em;
         display: inline-flex;
         align-items: center;
         margin-left: -2px;
         margin-right: -2px;

         transition: background-color 0.25s ease, color 0.25s ease,
            border-color 0.25s ease;

         .correct-icon,
         .incorrect-icon {
            visibility: hidden;
            margin-right: 0.25em;
         }

         .incorrect-icon {
            display: inline-block;
         }
         .correct-icon {
            display: none;
         }
      }

      .tempo-bpm {
         display: none;
      }

      &.correct-value {
         .tempo-value {
            .incorrect-icon {
               display: none;
            }
            .correct-icon {
               display: inline-block;
            }
         }
      }

      @media (min-width: 315px) and (max-width: 499px) and (max-height: 550px),
         (min-width: 675px) and (max-height: 550px),
         (min-width: 300px) and (max-width: 449px) and (min-height: 551px),
         (min-width: 615px) and (min-height: 551px) {
         .tempo-bpm {
            display: inline;
         }
      }
   }

   &.compare-answer .tempo-control {
      button {
         background-color: var(--semantic-error);
         color: var(--semantic-error-text);
         border-color: var(--semantic-error-text);

         &:hover:not(:disabled) {
            border-color: var(--brand-dark-orange) !important;
         }
      }

      .tempo-value {
         color: var(--semantic-error-text);
         background-color: var(--semantic-error-background);
      }

      .correct-icon,
      .incorrect-icon {
         visibility: visible;
      }

      &.correct-value {
         button {
            background-color: var(--semantic-success);
            color: var(--semantic-success-text);
            border-color: var(--semantic-success-text);
         }

         .tempo-value {
            color: var(--semantic-success-text);
            background-color: var(--semantic-success-background);
         }
      }

      @media (prefers-color-scheme: dark) {
         button {
            border-color: var(--semantic-error);
         }
         .tempo-value {
            color: var(--semantic-error);
         }

         &.correct-value {
            button {
               border-color: var(--semantic-success);
            }
            .tempo-value {
               color: var(--semantic-success);
            }
         }
      }
   }

   .sequencer-progress {
      height: 20px;

      svg {
         height: 5px;
         color: var(--brand-light-orange);
      }
   }

   .step-sequencer {
      -webkit-tap-highlight-color: transparent;
      position: relative;

      .step-sequencer-rows {
         display: grid;
         grid-template-columns: 75px 1fr;
         max-height: var(--sequencer-zone-height);
         overflow: auto;
      }

      .step-sequencer-row-outer-wrapper {
         width: 100%;
         overflow: auto;
         overscroll-behavior-x: none;
      }

      .step-sequencer-row-inner-wrapper {
         width: calc(var(--step-count) * 40px);
         position: relative;
      }

      .step-sequencer-row {
         height: 55px;
         overflow-y: hidden;
      }

      button {
         --pulse-animation-scale: 1.05;
         --pulse-animation-scale-b: 1.0501;
         vertical-align: bottom;
         width: 30px;
         height: 45px;
         border-radius: 10px;
         background-color: var(--brand-light-green);
         margin: 5px;
         color: var(--text-color);
         border: 2px solid;
         padding: 0;
         transition: background-color 0.125s ease, color 0.125s ease;
         outline: 0;

         &:nth-of-type(8n-3),
         &:nth-of-type(8n-2),
         &:nth-of-type(8n-1),
         &:nth-of-type(8n) {
            background-color: var(--background-color);
         }
      }

      &:not(.compare-answer) button:not(:disabled) {
         cursor: pointer;

         &:hover {
            border-color: var(--brand-dark-orange) !important;
            transform: scale(1.025);
         }
      }
   }

   @media (prefers-color-scheme: dark) {
      .step-sequencer button {
         background-color: var(--background-color);

         &:nth-of-type(8n-3),
         &:nth-of-type(8n-2),
         &:nth-of-type(8n-1),
         &:nth-of-type(8n) {
            background-color: var(--brand-dark-green);
         }
      }
   }

   .step-icon-wrapper {
      width: 100%;
      text-align: center;
      opacity: 0;
      transition: opacity 0.125s ease;
   }

   &:not(.compare-answer.reference-playing) {
      .selected {
         background-color: var(--brand-orange);
         color: var(--brand-darker-orange);
         border-color: var(--brand-darker-orange);
      }

      .selected .step-icon-wrapper {
         opacity: 1;
      }
   }

   &.compare-answer {
      &:not(.reference-playing) {
         .selected {
            background-color: var(--semantic-error);
            color: var(--semantic-error-text);
            border-color: var(--semantic-error-text);
         }
      }

      &:not(.selected-playing) {
         .reference {
            background-color: var(--semantic-warn);
            color: var(--semantic-warn-text);
            border-color: var(--semantic-warn-text);
         }
      }

      .selected.reference {
         background-color: var(--semantic-success);
         color: var(--semantic-success-text);
         border-color: var(--semantic-success-text);
      }
   }

   .selected-icon,
   .missing-icon,
   .incorrect-icon,
   .correct-icon {
      display: none;
   }

   .selected:not(.labeled) .selected-icon {
      display: inline;
   }

   &.compare-answer {
      .selected .selected-icon {
         display: none;
      }

      &:not(.reference-playing)
         .selected:not(.reference):not(.labeled)
         .incorrect-icon,
      &:not(.selected-playing)
         .reference:not(.selected):not(.labeled)
         .missing-icon,
      .reference.selected:not(.labeled) .correct-icon {
         display: inline;
      }

      &:not(.reference-playing) .selected:not(.reference) .step-icon-wrapper,
      &:not(.selected-playing) .reference:not(.selected) .step-icon-wrapper,
      .reference.selected .step-icon-wrapper {
         opacity: 1;
      }
   }

   .step-sequencer-cursor {
      display: none;
      top: 0;
      bottom: 0;
      width: 40px;
      position: absolute;
      border-radius: 10px;
      z-index: 3;
      pointer-events: none;

      transform: translateX(calc(var(--current-step) * 40px));

      .step-overlay {
         width: 30px;
         height: 45px;
         border-radius: 10px;
         background-color: hsla(0deg 0% 100% / 27%);
         border: 2px solid var(--brand-orange);
         margin: 10px 5px;

         &:first-child {
            margin-top: 5px;
         }
         &:last-child {
            margin-bottom: 0;
         }
      }
   }

   &.selected-playing .step-sequencer-cursor,
   &.compare-answer.reference-playing .step-sequencer-cursor {
      display: block;
   }

   @media (prefers-color-scheme: dark) {
      .step-sequencer-cursor .step-overlay {
         background-color: hsla(0deg 0% 100% / 27%);
         border-color: var(--brand-light-orange);
      }
   }

   .piano-roll {
      --dark-note-row-color: ${darken(0.075, '#d1e8e8')};
      position: relative;

      .user-note rect,
      .user-note .sustained-note {
         fill: transparent;
         stroke: transparent;
         stroke-width: 2px;
      }

      .user-note svg,
      .reference-note svg {
         stroke-width: 3;
      }

      .user-note rect:not(.note-resize-handle):not(.note-touch-delete-rect),
      .user-note .sustained-note {
         fill: var(--brand-green);
         stroke: var(--brand-dark-green);
      }

      .pending-note {
         fill: var(--hover-color);
         stroke-width: 2px;
         stroke: var(--brand-dark-orange);
      }

      .pending-note-highlight {
         fill: var(--brand-orange);
         opacity: 0.2;
      }

      .reference-note rect,
      .reference-note .sustained-note {
         pointer-events: none;
         fill: none;
         stroke-width: 2px;
         fill: var(--semantic-warn);
         stroke: var(--semantic-warn-text);
      }

      .reference-note svg {
         pointer-events: none;
         stroke: var(--semantic-warn-text);
      }

      .note-resize-handle {
         cursor: ew-resize;
      }

      .note-touch-resize-handle {
         stroke: var(--brand-dark-orange);
         fill: var(--brand-orange);
         stroke-width: 2;
      }

      .note-touch-delete-icon {
         stroke: var(--brand-dark-orange);
      }

      .note-touch-delete-rect {
         stroke: transparent;
         fill: transparent;
      }
   }

   .piano-roll-touch {
      .note-resize-handle {
         display: none;
      }
   }

   &.compare-answer .piano-roll {
      .user-note rect:not(.note-resize-handle),
      .user-note .sustained-note {
         fill: var(--semantic-error);
         stroke: var(--semantic-error-text);
      }
      .reference:not(.incorrect-length) rect:not(.note-resize-handle),
      .reference:not(.incorrect-length) .sustained-note {
         fill: var(--semantic-success);
         stroke: var(--semantic-success-text);
      }

      .user-note svg {
         stroke: var(--semantic-error-text);
      }
      .reference:not(.incorrect-length) svg {
         stroke: var(--semantic-success-text);
      }
   }

   &.compare-answer {
      &.reference-playing .user-note:not(.reference),
      &.reference-playing .user-note.incorrect-length,
      &.selected-playing .reference-note {
         display: none;
      }
   }

   .piano-roll-wrapper {
      display: grid;
      grid-template-columns: 75px 1fr;
      max-height: var(--sequencer-zone-height);
      overflow: auto;
   }

   .piano-roll-notes-wrapper {
      /* This padding is needed to prevent a double scroll bar issue that happens only in guess which browser... yep, Safari */
      padding-bottom: 1px;

      display: inline-block;
      position: relative;
      user-select: none;
      width: 100%;
      overflow: auto;
      overscroll-behavior-x: none;
   }

   .piano-roll-close {
      font-family: var(--content-font);
      font-weight: bold;
      position: absolute;
      top: 20px;
      right: 0;

      button {
         background: var(--background-color);

         svg {
            stroke-width: 3;
         }

         @media (max-height: 500px), (max-width: 500px) {
            padding: 0.25em;
         }
      }
   }

   .piano-roll-keyboard {
      border-right: 1px solid var(--text-color);
   }

   .piano-roll-key,
   .piano-roll-key-label {
      fill: var(--text-color);
   }

   .piano-roll-key-label {
      font: 16px;
      font-family: var(--content-font);
   }

   .piano-roll-key-gap {
      stroke: var(--brand-light-green);
   }

   .piano-roll-grid-row {
      fill: var(--dark-note-row-color);
   }

   .piano-roll-grid-row-gap {
      stroke: var(--dark-note-row-color);
   }

   .piano-roll-grid-column {
      stroke: var(--dark-note-row-color);
   }
   .piano-roll-grid-column-beat {
      stroke: var(--brand-light-green);
      stroke-width: 2;
   }
   .piano-roll-grid-column-bar {
      stroke: var(--brand-green);
      stroke-width: 2;
   }

   @media (prefers-color-scheme: dark) {
      .piano-roll {
         --dark-note-row-color: var(--brand-darker-green);
         --dark-note-row-color: ${darken(0.02, '#003536')};

         .pending-note-highlight {
            fill: var(--brand-light-orange);
         }
      }
      .piano-roll-keyboard {
         background-color: var(--brand-light-green);
      }

      .piano-roll-key,
      .piano-roll-key-label {
         fill: var(--background-color);
      }

      .piano-roll-key-gap {
         stroke: var(--brand-dark-green);
      }

      .piano-roll-grid {
         background-color: var(--brand-darker-green);
      }

      .piano-roll-grid-column-beat {
         stroke: ${darken(0.04, '#003536')};
         stroke: var(--brand-dark-green);
         stroke: ${darken(0.04, '#003536')};
      }
      .piano-roll-grid-column-bar {
         /* stroke: ${darken(0.02, '#003536')}; */
         stroke: var(--brand-green);
         stroke: var(--brand-dark-green);
         stroke: ${darken(0.08, '#003536')};
      }
   }

   .piano-roll-cursor-svg {
      pointer-events: none;
   }

   .piano-roll-cursor {
      stroke: var(--brand-light-orange);
      stroke-width: 4;
      visibility: hidden;
   }

   &.selected-playing .piano-roll-cursor,
   &.compare-answer.reference-playing .piano-roll-cursor {
      visibility: visible;
   }
`;

export { SequencerStyles };
